export const DRAFT_APPROVED_ELSEWHERE_MESSAGE =
  "This draft has already been approved elsewhere.";

export const buildDraftApprovedRedirect = ({ routeName, params, query }) => {
  const nextQuery = { ...(query || {}) };
  delete nextQuery.forceDraft;

  return {
    name: routeName || "Question Page",
    params: { ...(params || {}) },
    query: nextQuery,
  };
};
